











































import { Prop, Component, Vue } from "vue-property-decorator";
import ProjectListActions from "./ProjectListActions.vue";
import { isNewProject } from "@/preferences";
import CloseDateModal from "@/ui/order/components/CloseDateModal.vue";
import { format } from "date-fns";
import { CloseProjectCommand } from "@/api/project-api";
import StatusPage from "@/views/StatusPage.vue";

export interface IProjectListItem {
  project: {
    id: string;
    name: string;
    icon: string;
  };
  place: string;
  client: {
    company: string;
    staff: string;
  };
  createdAt: string;
  status: string;
  _rowVariant: string;
  statusProject?: number;
  colorName?: string | Object;
  start?: string;
  end: string;
  closed: boolean;
}

export interface CloseCommandProject {
  id: string | number;
  date: string;
  start?: string;
}

@Component({
  components: {
    ProjectListActions,
    CloseDateModal,
    StatusPage
  },
  methods: { isNewProject }
})
export default class VProjectList extends Vue {
  // TODO: itemsを取ってくるところまでひとまとめでもいい気がする
  @Prop({ required: true }) items!: IProjectListItem[];
  @Prop({ default: "" }) message!: string;

  data: CloseCommandProject = {
    id: "",
    date: ""
  };
  fields = [
    { key: "project", label: "現場名", sortable: true },
    { key: "place", label: "住所", sortable: true },
    { key: "client", label: "発注者", sortable: true },
    { key: "createdAt", label: "登録日", sortable: true },
    { key: "status", label: "状態", sortable: true },
    { key: "actions", label: "" }
  ];

  compare: (a: any, b: any) => number | null = () => null;

  changeSortType({ sortBy }: { sortBy: string }) {
    // projectとclientはオブジェクトなので特別な比較関数を用意する
    if (sortBy === "project") {
      this.compare = this.compareProject;
    } else if (sortBy === "client") {
      this.compare = this.compareClient;
    } else {
      this.compare = () => null;
    }
  }

  private compareProject(a: IProjectListItem, b: IProjectListItem) {
    if (a.project.name < b.project.name) return -1;
    if (a.project.name > b.project.name) return 1;
    return 0;
  }

  private compareClient(a: IProjectListItem, b: IProjectListItem) {
    if (a.client.company < b.client.company) return -1;
    if (a.client.company > b.client.company) return 1;
    return 0;
  }

  handleShowModal(item: IProjectListItem) {
    this.data = {
      id: item.project.id,
      date: item.end ? format(new Date(item.end), "yyyy-MM-dd") : "",
      start: item.start
    };

    (this.$refs.closeDateModal as any).show();
  }

  handleSave(item: CloseCommandProject) {
    const command: CloseProjectCommand = {
      id: Number(item.id),
      closed:
        new Date(item.date).getTime() <=
        new Date(format(new Date(), "yyyy-MM-dd")).getTime(),
      endDate: item.date
    };

    this.$emit("close", command);
  }
}
